import { graphql } from "relay-runtime"

const chPartnerUsersQuery = graphql`
  query chPartnerUsersQuery($skip: Boolean!) {
    ch_partnerUsers @skip(if: $skip) {
      nodes {
        id
        userName
        phoneNumber
        email
        isDoc2U
        isActive
        userTag
        careProvider {
          streetAddress
          postalCode
          city
          countryCode
        }
      }
    }
  }
`

export { chPartnerUsersQuery as ch_PartnerUsersQuery }
